import styled from 'styled-components';

export const StyledIcon = styled.div`
  ${({ theme }) => `
    &.icon {
      width: 26px;
      height: 24px;
    }

    & > * {
      width: 100% !important;
      height: 100% !important;
    }
  `}
`;
